import { FeaturePermission } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_COMMAND_STATE, WIZ_EVENT_TYPE,  
  CONFIRMATION_MODE, CONFIRMATION_RESULT, FILTER_TYPE } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  FilterObj,
  WizButton,
  WizCheckbox,
  WizDatasource,
  WizGroupCommand,
  WizPopUp,
  WizTextInput,
  WizValidationContainerDirective,
  WizVgroup,
  WizAgGrid,
  BATCH_FILE_FORMAT,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { ProfileCmd } from '@wizeoo/akm-common-lib';
import { RoleCmd } from '@wizeoo/akm-common-lib';
import { UserServiceCmd } from '@wizeoo/akm-common-lib';
import { MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { PermissionAccess } from '@wizeoo/akm-common-lib';
import { AgLabelValidityRenderer } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE, FEATURE_PERIMETER, UserContextService } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { RoleVO } from '@wizeoo/akm-common-lib';
import { UserVO } from '@wizeoo/akm-common-lib';
import { PermissionVisibility, StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { ProfileVO } from '@wizeoo/akm-common-lib';
import { UserApplicationVO } from '@wizeoo/akm-common-lib';
import { CustomTooltip } from '@wizeoo/akm-common-lib';
import { RoleAccessRenderer } from '@wizeoo/akm-common-lib';
import { CellClickedEvent } from 'ag-grid-community';
import { GridOptions } from 'ag-grid-community';
import { FIELD_KIND } from '@wizeoo/akm-compute-lib';
import { PivotCellEditor } from '@wizeoo/akm-common-lib';

/**
 * Vue d'administation des utilisateurs
 * Author : mdi
 */
@Component({
  selector: 'user-view',
  templateUrl: './user.view.html',
})
export class UserView extends BaseView {
  /** Button d'ajout de user */
  // @ViewChild('btnCreate', { read: WizButton, static: false }) btnCreate: WizButton;
  /** Text input de saisie du prénom */
  @ViewChild('tiFname', { read: WizTextInput, static: false }) tiFname: WizTextInput;
  /** Text input de saisie du nom */
  @ViewChild('tiLname', { read: WizTextInput, static: false }) tiLname: WizTextInput;
  /** référence de la checkbox de blocage */
  @ViewChild('chbLock', { read: WizCheckbox }) private chbLock: WizCheckbox;
  /** Zone de detail */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;
  /** Zone de validation des champs de saisie */
  @ViewChild(WizValidationContainerDirective, { read: WizValidationContainerDirective, static: false })
  private vgEditionContainer: WizValidationContainerDirective;
  /** Bouton de sauvegarde */
  @ViewChild('btnSave', { read: WizButton, static: false }) btnSave: WizButton;
  /** Bouton d'annulation de saisie */
  @ViewChild('btnCancel', { read: WizButton, static: false }) btnCancel: WizButton;
  /** Bouton de suppression du user ?? */
  // @ViewChild('btnRemove', { read: WizButton, static: false }) btnRemove: WizButton;
  // fitres
  /** le composant de filtre des rôles disponible  */
  @ViewChild('availableRolesFilter', { read: FilterComponent, static: false }) availableRolesFilter: FilterComponent;

  @ViewChild('agGrid') agGrid: WizAgGrid<any>; // grid

  constructor(elementRef: ElementRef) {
    super(elementRef);
  }

  private get _context(): UserContextService {
    return Model.getInstance().userContextService;
  }


  /** Data source de la liste de user */
  public userDS: WizDatasource<UserVO> = new WizDatasource<UserVO>([])
    .setFilter((u) => {
      // on affiche pas les users si ils n'ont pas de visions
      if (!Model.getInstance().visionCode) {
        return false;
      }
      return true;
    })
    .build();

  /**
   * configuration de l'affichage en multi liste
   */
  public multiDisplayConfig: MultiDisplayConfig<UserVO> = {
    model: Model.getInstance(),
    datasource: this.userDS,
    defaultMode: 'grid',
    onSelectionChanging: this.onWizEventSelectionChange.bind(this),
    grid: {
      enabled: true,
      columns: [
        // {
        //   headerName: '$.user.mail.$', field: 'mail', flex: 1, sortable: true, tooltipField: 'mail',
        // },
        { headerName: '$.user.firstname.$', field: 'firstname', width: 80, sortable: true, tooltipField: 'firstname' },
        {
          headerName: '$.user.lastname.$', field: 'lastname', width: 150, sortable: true, cellRenderer: 'labelValidityRenderer'
        }
      ],
      renderers: {
        labelValidityRenderer: AgLabelValidityRenderer,
      },
    },
    filter: {
      enabled: true,
      initFilter: this.initFilter.bind(this),
    },
  };

  private mainFilter: FilterComponent;

  private initFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  // colonne du grid des roles disponibles
  public availableRolesColumns: any[] = [
    { headerName: '$.roles.type.$', width: 80, field: 'trsKind' },
    { headerName: '$.common.code.$', width: 100, field: 'trsCode', resizable: true },
    { headerName: '$.roles.feature.$', flex: 1, minWidth: 250, maxWidth: 400, field: 'trsLabel', tooltipField: 'trsLabel', tooltipComponent: 'customTooltip', resizable: true },
    { headerName: '$.role.kind.all.$', width: 80, field: 'doAll', cellRenderer: (params: any) => this.roleCrudRenderer('doAll', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.c.$', width: 80, field: 'doCreate', cellRenderer: (params: any) => this.roleCrudRenderer('doCreate', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.r.$', width: 80, field: 'doRead', cellRenderer: (params: any) => this.roleCrudRenderer('doRead', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.u.$', width: 80, field: 'doUpdate', cellRenderer: (params: any) => this.roleCrudRenderer('doUpdate', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.d.$', width: 80, field: 'doDelete', cellRenderer: (params: any) => this.roleCrudRenderer('doDelete', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.batch.$', width: 80, field: 'doBatch', cellRenderer: (params: any) => this.roleCrudRenderer('doBatch', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.common.keys.$', flex: 1, field: 'tags', resizable: true,
      editable: this.checkEditFilter.bind(this),
      datakind: FIELD_KIND.STRING,
      valueGetter: this.valueGetter.bind(this),
      valueFormatter: this.valueFormatter.bind(this),
      valueSetter: this.updateCell.bind(this),
      cellRenderer: (params: any) => this.roleFilterRenderer(params),
      type: 'filter'
    }
  ];

  private checkEditFilter(params: any): boolean {
    
    if (!Model.getInstance().permissionEngine.canUpdate(StaticFeatureEnum.VISION_USER)) {
      return false;
    }
    
    if (!this.maySetFilter(params.data)) { // seulement si ligne de vision
      return false;
    }

    return true;
  }

  /**
   * édition uniquement pour le champ filtre de la vision
   * @param data 
   * @returns 
   */
  private mayShowFilter(data: FeaturePermission): boolean {
    if(!!(data?.dynamic && data?.feature?.kind === StaticFeatureEnum.VISION) || !!data.profile) {
      return true;
    }
    return false;
  }

  /**
   * édition uniquement pour le champ filtre de la vision
   * @param data 
   * @returns 
   */
  private maySetFilter(data: FeaturePermission): boolean {
    if(!!data?.dynamic && data?.feature?.kind === StaticFeatureEnum.VISION) {
      return true;
    }
    return false;
  }

  private onCellDouble(params: any): void {
    if (!this.maySetFilter(params.data)) { // cellule éditable, pas de 2x clic
      return;
    } 
  }

  /**
   * clic sur le crayon d'édition (ou édition de la cellule ?)
   * @param params tout le bazard { colDef, data, column, event, value }
   */
  onCellEdit(params: CellClickedEvent) {  
    // console.log('onCellEdit', params);
    if (!this.maySetFilter(params.data)) { // seulement si autorisé
      return;
    }

    this.agGrid.api.setFocusedCell(params.rowIndex, params.column);
    this.agGrid.api.startEditingCell({rowIndex: params.rowIndex, colKey: params.column})
  }


  private roleFilterRenderer(params: any): string {   
    let result: string = `<div></div>`;
    if(this.mayShowFilter(params.data)) {
      result = `<div class="cell-edit-lbl-noscen">${params.valueFormatted}</div>`;
    }
    if(this.maySetFilter(params.data)) {
      result += `<i class="wiz-icon- cell-edit-icon">edit</i>`;
    }
    return result;
  }

  private valueGetter(params: any): any {
    let result: string = '';
    if(this.mayShowFilter(params.data)) {

      if(!!params.data.profile) { // affichage de la conf d'un profile
        if(params.data.profile.tags) {
          result = JSON.stringify(params.data.profile.tags);
        }
      } else {
        let goodApp: UserApplicationVO = this.clone.userAppsByPerimeter?.get(Model.getInstance().domainCode)?.get(Model.getInstance().businessUnitCode)?.get(Model.getInstance().visionCode)?.get("APP");
        if(!!goodApp?.tags) {
          result = JSON.stringify(goodApp.tags);
        }
      }


    }
    return result;
  }
  private valueFormatter(params: any): string {
    return params?.value?.toString().toUpperCase();
  }

  public updateCell(cell: any): boolean {
    // console.log('updateCell', cell);
    if (cell.newValue !== cell.oldValue) {
      // let goodRole: RoleVO = cell.data.roles?.filter(role => role.doRead === true)[0];

      let goodApp: UserApplicationVO = this.clone.userAppsByPerimeter?.get(Model.getInstance().domainCode)?.get(Model.getInstance().businessUnitCode)?.get(Model.getInstance().visionCode)?.get("APP");
      // goodApp.maintenanceFlag = WizMathUtils.createUUID(); // forcer l'update sur modif de children
      // if(cell.newValue) {
        try {
          goodApp.tags = JSON.parse(cell.newValue);
        } catch(e: any) {
          goodApp.tags = null;
        }
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
      this.manageComponents();
    }
    return true;
  }

  /** renderer de libellé des rôles disponible */
  public availableRolesRenderer = { labelRenderer: AgLabelValidityRenderer, 
    customTooltip: CustomTooltip, 
    accessRenderer: RoleAccessRenderer,
    pivotCellEditor: PivotCellEditor };

  public rolesByFeature: WizDatasource<FeaturePermission> = new WizDatasource([]) // le tableau des rôles
    .setFilter(this.featureFilterFunc.bind(this))
    .setSelectionMode('none')
    .setSortFields([{ property: 'code', way: 'asc' }])
    .build();

  /** configuration de l'agGrid */
  gridOptions: GridOptions = { 
    suppressRowClickSelection: true, // pas de sélection directe, on gère nous même
    onCellDoubleClicked: (params) => this.onCellDouble(params), // 2x clic pour copy content
    stopEditingWhenCellsLoseFocus: true, // 
  };


  /**
   * Méthode de filtre des roles disponibles
   * @param item Element de la liste de role testé
   * @returns boolean, true si l'element correspond au filtre, false sinon
   */
  private featureFilterFunc(item: FeaturePermission): boolean {
    return !!this.availableRolesFilter ? this.availableRolesFilter.checkVisible(item) : false;
  }

  /** affichage ou non du panneau detail */
  public get showDetail(): boolean {
    return !!this._currentUser && Model.getInstance().permissionEngine.hasAnyPermission({
      feature: StaticFeatureEnum.VISION_USER,
      accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE, PermissionAccess.READ],
      visibility: PermissionVisibility.DISABLED
    });
  }

  /** user dans la zone de détail */
  private _currentUser: UserVO = undefined;
  public get currentUser(): UserVO {
    return this._currentUser;
  }
  public set currentUser(user: UserVO) {
    this._currentUser = user;
    // Sauvegarde dans l'engine pour sélection par défaut ultérieure
    Model.getInstance().userEngine.currentEditedUser = user;
    // clone le currentUser pour pouvoir supprimer les modifications en cas d'annulation
    this.clone = this._currentUser ? Model.getInstance().userEngine.clone(user) : undefined;
  }

  private visionApp: UserApplicationVO = null; // conf du user

  /**
   * clone du currentUser
   * permet de ne pas altérer l'instance
   */
  private clone: UserVO;

  /* #############################################################
                        CYCLE DE VIE WizView
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const calls = [];
    // Chargement des roles si vide
    calls.push(new ProfileCmd(Model.getInstance()).find());
    calls.push(new RoleCmd(Model.getInstance()).find());
    // Chargement des users dans tous les cas
    calls.push(new UserServiceCmd(Model.getInstance()).find());

    return new WizGroupCommand().configure(calls);
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {
    super.wizSynchronizeData();

    super.managePermissions([
      {
        feature: StaticFeatureEnum.VISION_USER,
        permissions: [
          {
            component: this.vgDetailZone,
            accesses: [PermissionAccess.READ, PermissionAccess.CREATE, PermissionAccess.UPDATE],
            visibility: PermissionVisibility.DISABLED,
          }
        ],
      },
    ]);

    // Alimentation de la liste des users, on clone pour éviter une duplication lors de l'ajout d'un user
    this.userDS.setSource([...Model.getInstance().usersMap.values()]);

    const user: UserVO = Model.getInstance().userEngine.getCurrentInstance(Model.getInstance().userEngine.currentEditedUser);

    if (Model.getInstance().visionCode) {
      if (!!user && !user.loaded) {
        new UserServiceCmd(Model.getInstance())
          .getUser(user, (cmd) => {
            this.finalizeSynchronizeData(user);
          })
          .execute();
      } else {
        this.finalizeSynchronizeData(user);
      }
    } else {
      this.finalizeSynchronizeData(null);
    }
  }

  /**
   * Finalisation de synchronisation de la vue
   * @param pUser Le user alimenté par défaut provenant du contexte ou null
   */
  protected finalizeSynchronizeData(pUser: UserVO): void {
    this.currentUser = pUser;

    this.userDS.setSelectedItems([this.currentUser]);

    this.buildFilter();
    this.buildAvailableRolesFilters();
    this.feed();
  }

  /**
   * Mise en place des écouteurs
   */
  public wizAddListener(): void {
    super.wizAddListener();
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
    // Save
    WizEventManager.addListener(this, this.btnSave, WIZ_EVENT_TYPE.CLICK, this.save);
    // Cancel
    WizEventManager.addListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK, this.askForCancel);

    // écoute des filtres
    WizEventManager.addListener(this, this.availableRolesFilter, WIZ_EVENT_TYPE.CHANGE, () =>
      this.rolesByFeature.refresh()
    );
  }

  /**
   * Suppression des écouteurs
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.btnSave, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.availableRolesFilter, WIZ_EVENT_TYPE.CHANGE);
  }

  /** mémorisation du filtre */
  wizOnDestroy(): void {
    super.wizOnDestroy();
    // this._context.saveLocalFilter(this.mainFilter);
    // this._context.saveLocalFilter(this.availableRolesFilter, 'AVAILABLE_FILTER');
  }

  public onWizEventSelectionChange(event: any): void {
    // pas de désélection d'un item
    if (this.userDS.isSelected(event.value)) {
      event.preventDefault();
      return;
    }

    // empêche le changement de selection quand il y a une modification de model en cours
    if (ViewData.wizUpdateModel) {
      // on stop le fonctionnement par défaut pour afficher la pop, on sélectionnera l'item seulement si le user confirme
      event.preventDefault();
      const target: UserVO = event.value as UserVO;

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSelectCallback.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        target,
        null,
        this.clone
      ).show();
    } else {
      this.selectUser(event.value);
    }
  }

  /**
   * Confirmation d'abandon de modifs
   * Callback de la  WizPopupConfirmation déclenché quand on navigue dans la liste
   * alors qu'il y a une modification de model en cours
   * @param result Confirmation
   */
  private confirmSelectCallback(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const user: UserVO = result.data;
      // Sélection du nouvel élément
      this.selectUser(user as UserVO);
      this.userDS.toggle(this.currentUser);
    }
  }

  /**
   * Selection d'un user
   * @param pUser: Le User à sélectionner
   */
  public selectUser(pUser: UserVO) {
    if (pUser.loaded) {
      this.doSelectUser(pUser);
    } else {
      new UserServiceCmd(Model.getInstance())
        .getUser(pUser, (pCmd: UserServiceCmd) => {
          this.doSelectUser(pUser);
        })
        .execute();
    }
  }

  private doSelectUser(pUser: UserVO) {
    this.currentUser = pUser;

    // Alimentation de la zone de saisie
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
    this.feed();
  }

  /* ##############################################################################
                    Panneau gauche : Liste, sélection, filtres
     ############################################################################## */

  /**
   * construction de la zone de filtre des users
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildFilter(event: WizEvent = null): void {
    // liste de filtres complémentaires
    const filter = [];

    filter.push(FilterObj.create('withoutRole', '$.user.filter.show.without.role.$', FILTER_TYPE.TRUELEAN, false, 1));
    filter.push(FilterObj.create('locked', '$.user.filter.show.not.locked.$', FILTER_TYPE.TRUELEAN, false, 2));

    this.mainFilter.configure(['firstname', 'trsLabel'], null, filter);
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.mainFilter);
  }

  /**
   * construction de la zone de filtre des roles
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildAvailableRolesFilters(event: WizEvent = null): void {
    this.availableRolesFilter.configure(['trsCode', 'trsKind', 'trsLabel'], null, null);
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.availableRolesFilter, 'AVAILABLE_FILTER');

    this.rolesByFeature.refresh();
  }

  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.USER, BATCH_FILE_FORMAT.JSON);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.USER);
        break;
    }
  }

  /* #########################################
                    Detail
     ######################################### */

  /**
   * Initialisation des valeurs des champs dans le conteneur d'edition en fonction du currentUser
   */
  public feed(): void {
    if (this.currentUser) {
      this.tiFname.wizValue = this.clone.firstname;
      this.tiLname.wizValue = this.clone.lastname;

      // synchronisation de la checkbox d'activation
      this.chbLock.wizChecked = this.clone.locked;

      // chargement de la conf user
      this.visionApp = Model.getInstance().userEngine.getUserApp(
        this.clone,
        Model.getInstance().domainCode,
        Model.getInstance().businessUnitCode,
        Model.getInstance().visionCode,
        FEATURE_PERIMETER.APP,
        true,
        true
      );


      const featuresMap: Map<string, FeaturePermission> = Model.getInstance().userAppEngine.generatePermission(); // map cible par code Feature

      // collecte des profiles
      const profs = Model.getInstance().profileMap.get(Model.getInstance().businessUnitCode)?.get(Model.getInstance().visionCode);
      // console.log('profileMap', profs);
      const filteredProfiles: ProfileVO[] = !!profs ? [...profs.values()].filter(p => Model.getInstance().userAppEngine.availableRoles(p)) : []; // filtrer le périmètre
      filteredProfiles.forEach((profile: ProfileVO) => {
        // TODO améliorer
        const featPerm: FeaturePermission = {
          businessUnitCode: profile.businessUnitCode,
          domain: profile.domain,
          visionCode: profile.visionCode,
          perimeter: profile.perimeter,
          profile,
          doProfile: true
        };
        featPerm.trsCode = profile.code;
        featPerm.trsKind = Model.getInstance().userAppEngine.getFeatureKind(featPerm);
        featPerm.trsLabel = profile.trsLabel;

        featuresMap.set(featPerm.profile.code, featPerm);
      });

      this.rolesByFeature.setSource(Array.from(featuresMap.values())); // affectation à la DS
      this.rolesByFeature.select([]);
    }

    this.manageComponents();

  }

  /** methode qui change la visibilité des composants */
  private manageComponents(): void {
    // Affichage des button en fonction du model update en prennant en compte si il y a eu modification ou non
    // Mise en commentaire du isEqual => marche pas
    if (ViewData.wizUpdateModel) {
      this.btnSave.wizDisabled = false;
      this.btnCancel.wizDisabled = false;
    } else {
      this.btnSave.wizDisabled = true;
      this.btnCancel.wizDisabled = true;
    }
  }

  /* ###############################
                  Saisie
     ############################### */

  public onPermissionCellClicked({ colDef, data, node, api, column }: CellClickedEvent) {
    if (!Model.getInstance().permissionEngine.canUpdate(StaticFeatureEnum.VISION_USER)) {
      return;
    }

    if (colDef.type === 'boolean') {
      if (Model.getInstance().userEngine.isAdmin(this.clone, this.visionApp)[0]) {
        return;
      }
      const perm: FeaturePermission = data;
      if (perm.doProfile) {
        if (Model.getInstance().userEngine.hasProfile(this.clone, perm.profile)) {
          Model.getInstance().userEngine.removeProfile(this.clone, perm.profile);
        } else {
          Model.getInstance().userEngine.addProfile(this.clone, perm.profile);
        }
        api.refreshCells({ force: true });
        // api.refreshCells({ force: true, rowNodes: [node], columns: [column], suppressFlash: true });
      } else {
        // gestion si roles
        const permToCheck: string = colDef.field;
        let roles: RoleVO[] = [];
        if (permToCheck === 'doAll') {
          const hasAllRoles = perm.roles.filter(r => Model.getInstance().userEngine.hasRole(this.clone, r, this.visionApp));

          // on avait déjà tous les rôles
          if (hasAllRoles.length === perm.roles.length) {
            hasAllRoles.forEach(r => this.visionApp.removeRole(r.code, r.featureCode));
          } else {
            perm.roles.filter(r => !hasAllRoles.includes(r)).forEach(r => this.visionApp.addRole(r));
          }

          api.refreshCells({ force: true, rowNodes: [node], suppressFlash: true });
        } else {
          roles = perm.roles.filter(r => !!r[permToCheck] && Model.getInstance().userEngine.hasRole(this.clone, r, this.visionApp));

          if (roles.length > 0) {
            // on est en status checked
            roles.forEach(r => this.visionApp.removeRole(r.code, r.featureCode));
          } else {
            perm.roles.filter(r => !!r[permToCheck]).forEach(r => this.visionApp.addRole(r));
          }

          api.refreshCells({ force: true, rowNodes: [node], suppressFlash: true });
        }
      }

      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
      this.manageComponents();
    } else if(colDef.type === 'filter') { // clic sur la colonne de filtre, uniquement pour la ligne de vision
      if(!!data.dynamic && data.feature?.kind === StaticFeatureEnum.VISION) {
      } else {
        return;
      }
    }
  }

  private roleCrudRenderer(permToCheck: string, perm: FeaturePermission): string {
    if (!this.clone || !this.visionApp) {
      return `<i class="fa-regular fa-square"></i>`;
    }

    if (perm.doProfile) {
      if (permToCheck !== 'doAll') {
        return ``;
      }

      if (this.visionApp.hasProfile(perm.profile) || this.visionApp.isAdmin()) {
        return `<i class="fa-regular fa-square-check"></i>`;
      } else {
        return `<i class="fa-regular fa-square"></i>`;
      }
    } else {
      if (Model.getInstance().userEngine.isAdmin(this.clone, this.visionApp)[0]) {
        return `<i class="fa-regular fa-square-check"></i>`;
      }

      if (permToCheck === 'doAll') {
        const hasAllRoles = perm.roles.filter(r => this.visionApp.hasRole(r));

        if (hasAllRoles.length === perm.roles.length) {
          return `<i class="fa-regular fa-square-check"></i>`;
        } else {
          return `<i class="fa-regular fa-square"></i>`;
        }
      } else {
        const permRoles = perm.roles.filter(r => !!r[permToCheck]);
        if (permRoles.length > 0) {
          if (permRoles.filter(r => this.visionApp.hasRole(r)).length > 0) {
            return `<i class="fa-regular fa-square-check"></i>`;
          } else {
            return `<i class="fa-regular fa-square"></i>`;
          }
        } else {
          return ``;
        }
      }
    }
  }


  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    switch (e.component) {
      case this.tiFname:
        this.clone.firstname = this.tiFname.wizValue;
        WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
        break;
      case this.tiLname:
        this.clone.lastname = this.tiLname.wizValue;
        WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
        break;
      case this.chbLock:
        this.clone.locked = this.chbLock.wizChecked;
        if (this.chbLock.wizChecked) {
          // TODO cabler lockedOn, la date de verrouillage
        }
        WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
        break;
    }
    this.manageComponents();
  }

  /* #####################################
        VALIDATION DE SAISIE
    ##################################### */

  /**
   * Demande d'annulation de saisie
   */
  private askForCancel(): void {
    // open confirmation popup
    WizPopUp.confirm(
      '$.common.pending.update.title.$',
      '$.common.pending.update.detail.$',
      this.doCancel.bind(this),
      CONFIRMATION_MODE.YES_NO,
      this.currentUser,
      null
    ).show();
  }

  /**
   * confirmation de l'annulation de saisie
   */
  private doCancel(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.YES) {
      this.reset();
    }
  }

  /**
   * Annulation des modifications
   */
  public reset() {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
    if (this.currentUser) {
      if (!this.currentUser.exist) {
        // this.addUser(ConfirmationResultObj.build(CONFIRMATION_RESULT.CONFIRM, this.currentUser));
      } else {
        this.clone = Model.getInstance().userEngine.clone(this.currentUser);
        this.feed();
      }
    }
  }

  /** Sauvegarde */
  public save(): void {
    // Vérification de la saisie
    const errors = this.vgEditionContainer.check(true, true);
    if (errors && errors.length === 0) {
      // Mise à jour des rôles
      const visionApp: UserApplicationVO = Model.getInstance().userEngine.getUserApp(
        this.clone,
        Model.getInstance().domainCode,
        Model.getInstance().businessUnitCode,
        Model.getInstance().visionCode,
        FEATURE_PERIMETER.APP,
        true,
        true
      );
      visionApp.doNone = false;

      Model.getInstance().widgetEngine.resetUserGlobalFilter(); // reset des filtres users
      // si le user est valide on persiste les modifications
      Model.getInstance().userAppEngine.merge(visionApp, Model.getInstance().userEngine.getUserAppFromApp(this.currentUser, visionApp), this.mergeCallback.bind(this));
    }
  }

  /**
   * Retour de service merge
   * @param  bddPersist: UserVO
   * @param status le statut de retour du service
   * @return boolean: vrai si la comande est en succes
   */
  private mergeCallback(bddPersist: UserApplicationVO[], status: string): boolean {
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      // mise a jour du current user et du clone
      this.currentUser = Model.getInstance().userEngine.getUserById(bddPersist[0].ownerId);

      this.clone = Model.getInstance().userEngine.clone(this.currentUser);
      this.userDS.itemUpdated([this.currentUser]);

      // Si le User se modifie lui même, on le met à jour pour avoir les roles dans le model et les appliquer tout de suite
      if (this.currentUser.id === Model.getInstance().connectedUser.id) {
        // TODO alimentation du contexte ??
        Model.getInstance().connectedUser = new UserVO(Model.getInstance(), this.currentUser.source);
        Model.getInstance().tabEngine.refreshTabs();
      }

      this.feed();
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
      return true;
    }

    return false;
  }
}
